import { useState } from 'react'
import { fetcher, AdminLevelRewardAssignmentsEndpoints, IUseLevelRewardAssignments } from '@olagg/api-hooks'
import { AdminLevelRewardAssignment } from '@olagg/db-types'

interface LevelRewardAssignmentsResponse {
  levelRewardAssignments: AdminLevelRewardAssignment[]
  meta: {
    count: number
  }
}

const useLevelRewardAssignments = () => {
  const [loading, setLoading] = useState(false)

  const getLevelRewardAssignments = async (filter: IUseLevelRewardAssignments): Promise<LevelRewardAssignmentsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminLevelRewardAssignmentsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching level reward assignments:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const retryLevelRewardAssignment = async (id: string): Promise<void> => {
    try {
      const endpoint = AdminLevelRewardAssignmentsEndpoints.retry(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error retrying level reward assignment:', error)
      throw error
    }
  }

  return {
    loading,
    getLevelRewardAssignments,
    retryLevelRewardAssignment,
  }
}

export default useLevelRewardAssignments
